const STRINGS = {
    login: 'login',
    nameReq: 'Name field is required.',
    fileReq: 'File is required.',
    descriptionReq: 'Description is required.',
    firstNameReq: 'First name field is required.',
    fieldReq: 'This field is required.',
    phoneReq: 'Phone number field is required.',
    metaReq: 'Meta title field is required.',
    lastNameReq: 'Last name field is required.',
    displayNameReq: 'Display name field is required.',
    invalidEmail: 'The email must be a valid email address.',
    emailReq: 'Please enter email address',
    invalidPassword: 'Password must be at least 8 characters in length.',
    passwordReq: 'Password field is required.',
    newPasswordReq: 'New Password field is required.',
    currentPasswordReq: 'Current Password field is required.',
    invalidConfirmPassword: 'Confirm password must be at least 8 characters in length.',
    confirmPasswordReq: 'Confirm password field is required.',
    passwordMissMatch: 'The password input and confirm password must match.',
    currentPassword: 'Current password is required',
    new_password: "New Password is required",
    confirm_password: "Confirm Password is required",
    titleReq: 'Title is required.',
    projectNameReq: 'Project Name is required.',
    addressReq: 'Address is required.',


}
export default STRINGS;